import React from 'react';

import ShareIcon from '../../assets/svg-components/share_icon.svg';
import SquiggleLeft from '../../assets/svg-components/wavy_line_left.svg';
import SquiggleBottomRight from '../../assets/svg-components/wavy_line_right_bottom.svg';
import SquiggleTopRight from '../../assets/svg-components/wavy_line_right_top.svg';
import { StoreContext } from '../../store/store';
import { cn } from '../../utils/classname';
import { APP_CONTEXT, Context } from '../context/context';
import Footer from '../footer/footer';
import { Gradient } from '../gradient/gradient';
import Header from '../header/header';
import Loader from '../loader/loader';
import { Text } from '../text/text';
import { Translate } from '../translate';
import { useDevice } from '../with-device/with-device';
import './layout.scss';

export const Layout = ({ children }) => {
  const device = useDevice({});
  const contextValues = { ...APP_CONTEXT, device };

  const { state } = React.useContext(StoreContext);
  const activeCard = state?.activeCard;
  const wasFlipped = React.useRef(activeCard.isFlipped);

  const [overlayClass, setOverlayClass] = React.useState('');
  const [isShareDialogOpen, setIsShareDialogOpen] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (activeCard.isFlipped) {
      setOverlayClass('active');
      wasFlipped.current = true;
    } else if (wasFlipped.current) {
      setOverlayClass('closing');
      const timeoutId = setTimeout(() => {
        setOverlayClass('');
      }, 500);

      return () => clearTimeout(timeoutId);
    } else {
      setOverlayClass('');
    }
  }, [activeCard.isFlipped]);

  return (
    <Context.Provider value={contextValues}>
      <Loader isLoadingAPIs={[state.isLoading]}>
        <div className={cn('bd-layout', activeCard.id && activeCard.isFlipped && 'bd-layout--no-scroll')}>
          {overlayClass && <div className={`bd-layout--overlay ${overlayClass}`} />}
          <div className="bd-layout__wrapper">
            <Gradient colorTone="cool" top="-150px" right="-100px">
              <SquiggleTopRight className="bd-layout__squiggle top-right" />
            </Gradient>
            <Gradient colorTone="warm" top="750px" left="-100px">
              <SquiggleLeft className="bd-layout__squiggle left" />
            </Gradient>
            <Gradient colorTone="cool" bottom="-300px" right="50px">
              <SquiggleBottomRight className="bd-layout__squiggle bottom-right" />
            </Gradient>

            <div className="bd-layout__content">
              <Header isShareDialogOpen={isShareDialogOpen} setIsShareDialogOpen={setIsShareDialogOpen} />
              {children}
              <div onClick={() => setIsShareDialogOpen(true)} className="bd-intro-section__share-button">
                <ShareIcon className="bd-intro-section__share-button__icon" />
                <Text align="center" weight="bold" className="bd-intro-section__share-button__text">
                  <Translate id="translate.header.share" />
                </Text>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </Loader>
    </Context.Provider>
  );
};
